<template>
  <div class="content content-boxed">
    <div class="row">
      <div class="col-xs-12">
        <h1>{{ labelTitle[actualLanguage] }}</h1>
        <p>{{ labelMessage[actualLanguage] }}</p>

        <p><button @click="showModal('add-device-form')" type="button" class="btn btn-rounded btn-default align-left" name="button">{{ labelButton01[actualLanguage] }}</button></p>

        <button style="width: 240px;" @click="getCode" type="button" class="btn btn-rounded btn-default">
          <spinner size="small" v-if="gettingCode"></spinner>
          <span v-else>{{ labelButton02[actualLanguage] }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import Spinner from '@/components/Spinner'
import AddDeviceForm from '@/views/configuration/AddDeviceForm'
export default {
  data() {
    return {
      gettingCode: false,

      actualLanguage : "FR",
      labelTitle: {FR: "Jumelage d'appareil", EN: "Device binding"},
      labelMessage: {FR: "Vous n'avez pas d'appareils EVA enregistrés.", EN: "Your profile do not contain any registered EVA device"},
      labelButton01: {FR: "+ Ajouter un module pré-enregistré", EN: "+ Add registered module"},
      labelButton02: {FR: "Récuperer un code de jumelage", EN: "Get binding code"},


    }
  },
  components: {
    Spinner
  },

  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),
    getCode() {
      this.gettingCode = true
      this.$store.dispatch('sessionStore/bind').then((code)=> {
        this.showModal('binding-code')
        this.gettingCode = false
      }).catch((e)=> {
        this.gettingCode = false
        console.log(e);
      })
    },
  },
  created: function() {
    // Redirect outside the app using plain old javascript
    // window.location.href = "/static/404-not-found.html";
  }
}
</script>



// WEBPACK FOOTER //
// BindingCode.vue?f772979a